import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import URLHelpers from '../components/shared/url_helpers';

const {
  coreIdentityVerificationPath,
} = URLHelpers;

export const CoreIdentityVerificationRoute = (
  <Route
    key={coreIdentityVerificationPath}
    // v7 child routes must use relative paths (the v3 tree allowed absolute ones)
    path={coreIdentityVerificationPath.replace(/^\//, '')}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'onboarding' */
        '../identity_verification/statuses_index'
      )).default,
    })}
  />
);
